import { LoginUserType } from 'redhotpie-shared-lib/enum/User';
import ProfileMemberType from './profileMemberType';
import ProfilePhoto from './profilePhoto';
import { MemberLevelUserProfile } from 'redhotpie-shared-lib/enum/MemberLevelUserProfile';

export default class ProfileSummary {
  memberId: number;
  userName: string;
  memberType: number;
  memberTypeTitle: ProfileMemberType;
  age1: number;
  age2: number;
  ageTitle: string;
  location: string;
  matchingInterests: number;
  mainPhoto: ProfilePhoto;
  isOnline: boolean;
  memberLevel: number;
  isDiamond: boolean;
  countryId: number;
  userType: LoginUserType;
  memberLevelType: string;
  isAdmin: boolean;
  memberLevelUserProfile: MemberLevelUserProfile;
  isViewable: boolean;

  constructor() {
    this.memberId = 0;
    this.userName = '';
    this.memberType = 0;
    this.memberTypeTitle = new ProfileMemberType(); // Initialize with a new instance
    this.age1 = 0;
    this.age2 = 0;
    this.ageTitle = '';
    this.location = '';
    this.matchingInterests = 0;
    this.mainPhoto = new ProfilePhoto(); // Initialize with a new instance
    this.isOnline = false;
    this.memberLevel = 0;
    this.isDiamond = false;
    this.countryId = 0;
    this.userType = LoginUserType.General; // Default enum value
    this.memberLevelType = '';
    this.isAdmin = false;
    this.memberLevelUserProfile = MemberLevelUserProfile.Guest; // Default enum value
    this.isViewable = false;
  }
  /**
   * Static method to map a plain object (typically from an API response)
   * to a ProfileSummary instance, converting PascalCase keys to camelCase.
   * @param _obj The raw object to map from.
   * @returns A new ProfileSummary instance with mapped data.
   */
  static mappingObject(_obj: Record<string, any>): ProfileSummary {
    const obj = new ProfileSummary();

    obj.memberId = _obj.MemberID || obj.memberId;
    obj.userName = _obj.UserName || obj.userName;
    obj.memberType = _obj.MemberType || obj.memberType;
    // If MemberTypeTitle is an object, map it recursively
    if (_obj.MemberTypeTitle) {
      obj.memberTypeTitle = ProfileMemberType.mappingObject(_obj.MemberTypeTitle);
    }
    obj.age1 = _obj.Age1 || obj.age1;
    obj.age2 = _obj.Age2 || obj.age2;
    obj.ageTitle = _obj.AgeTitle || obj.ageTitle;
    obj.location = _obj.Location || obj.location;
    obj.matchingInterests = _obj.MatchingInterests || obj.matchingInterests;
    // Recursively map nested objects
    if (_obj.MainPhoto) {
      obj.mainPhoto = ProfilePhoto.mappingObject(_obj.MainPhoto);
    }
    obj.isOnline = _obj.IsOnline !== undefined ? _obj.IsOnline : obj.isOnline;
    obj.memberLevel = _obj.MemberLevel || obj.memberLevel;
    obj.isDiamond = _obj.IsDiamond !== undefined ? _obj.IsDiamond : obj.isDiamond;
    obj.countryId = _obj.CountryID || obj.countryId;
    obj.userType = _obj.UserType !== undefined ? _obj.UserType : obj.userType;
    obj.memberLevelType = _obj.MemberLevelType || obj.memberLevelType;
    obj.isAdmin = _obj.IsAdmin !== undefined ? _obj.IsAdmin : obj.isAdmin;
    // memberLevelUserProfile is now an enum, so directly assign the value
    obj.memberLevelUserProfile = _obj.MemberLevelUserProfile !== undefined ? _obj.MemberLevelUserProfile : obj.memberLevelUserProfile;
    obj.isViewable = _obj.IsViewable !== undefined ? _obj.IsViewable : obj.isViewable;

    return obj;
  }
}
